import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=7e8c42ea"
import script from "./DialogBox.vue?vue&type=script&lang=ts"
export * from "./DialogBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports